import React, { useState } from 'react';
import { FaArrowLeft, FaCheck, FaHeart, FaStar, FaCalendarAlt, FaMapMarkerAlt, FaGraduationCap, FaBriefcase } from 'react-icons/fa';
import { toast } from 'react-toastify';

const LifePartnerPreferences = ({ formData, onSubmit, onPrevious, loading, userId }) => {
    const [localData, setLocalData] = useState({
        looking_for: formData.looking_for || '',
        marit: formData.marit || '',
        age: formData.age || '',
        partner_education: formData.partner_education || '',
        partner_occupation: formData.partner_occupation || '',
        location: formData.location || ''
    });
    
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    // Looking For options
    const lookingForOptions = [
        { value: 'Life Partner', label: 'Life Partner' },
        { value: 'Friend', label: 'Friend' },
        { value: 'Dating', label: 'Dating' },
        { value: 'Marriage', label: 'Marriage' }
    ];

    // Merit/Status options
    const meritOptions = [
        { value: 'Never Married', label: 'Never Married' },
        { value: 'Divorced', label: 'Divorced' },
        { value: 'Widowed', label: 'Widowed' },
        { value: 'Separated', label: 'Separated' },
        { value: 'Any', label: 'Any' }
    ];

    // Age Gap options
    const ageGapOptions = [
        { value: 'Same Age', label: 'Same Age' },
        { value: '1-2 Years Younger', label: '1-2 Years Younger' },
        { value: '3-5 Years Younger', label: '3-5 Years Younger' },
        { value: '5-10 Years Younger', label: '5-10 Years Younger' },
        { value: '1-2 Years Older', label: '1-2 Years Older' },
        { value: '3-5 Years Older', label: '3-5 Years Older' },
        { value: '5-10 Years Older', label: '5-10 Years Older' },
        { value: 'Any Age', label: 'Any Age' }
    ];

    // Education options
    const educationOptions = [
        { value: 'High School', label: 'High School' },
        { value: 'Bachelor\'s Degree', label: 'Bachelor\'s Degree' },
        { value: 'Master\'s Degree', label: 'Master\'s Degree' },
        { value: 'PhD', label: 'PhD' },
        { value: 'Diploma', label: 'Diploma' },
        { value: 'MBBS', label: 'MBBS' },
        { value: 'Engineering', label: 'Engineering' },
        { value: 'MBA', label: 'MBA' },
        { value: 'CA', label: 'CA' },
        { value: 'CS', label: 'CS' },
        { value: 'Any Graduate', label: 'Any Graduate' },
        { value: 'Any Post Graduate', label: 'Any Post Graduate' },
        { value: 'Not Required', label: 'Not Required' }
    ];

    // Occupation options
    const occupationOptions = [
        { value: 'Government Employee', label: 'Government Employee' },
        { value: 'Private Employee', label: 'Private Employee' },
        { value: 'Business', label: 'Business' },
        { value: 'Doctor', label: 'Doctor' },
        { value: 'Engineer', label: 'Engineer' },
        { value: 'Teacher', label: 'Teacher' },
        { value: 'Lawyer', label: 'Lawyer' },
        { value: 'CA', label: 'CA' },
        { value: 'Banker', label: 'Banker' },
        { value: 'Software Professional', label: 'Software Professional' },
        { value: 'Military', label: 'Military' },
        { value: 'Student', label: 'Student' },
        { value: 'Not Working', label: 'Not Working' },
        { value: 'Any', label: 'Any' }
    ];

    // Location options
    const locationOptions = [
        { value: 'Around My Locality', label: '🏠 Around My Locality' },
        { value: 'Within Nepal', label: '🇳🇵 Within Nepal' },
        { value: 'Abroad', label: '✈️ Abroad' },
        { value: 'Within Nepal or Abroad Both', label: '🌍 Within Nepal or Abroad Both' },
        { value: 'Anywhere', label: '🌏 Anywhere in the World' }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalData({ ...localData, [name]: value });
        
        // Mark field as touched
        setTouched({ ...touched, [name]: true });
        
        // Clear error for this field
        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        setTouched({ ...touched, [name]: true });
        validateField(name, localData[name]);
    };

    const validateField = (fieldName, value) => {
        let error = '';
        
        switch (fieldName) {
            case 'looking_for':
                if (!value || value === '') {
                    error = 'Please select what you are looking for';
                }
                break;
            case 'marit':
                if (!value || value === '') {
                    error = "Partner's marital status preference is required";
                }
                break;
            case 'age':
                if (!value || value === '') {
                    error = 'Preferred age gap is required';
                }
                break;
            case 'location':
                if (!value || value === '') {
                    error = 'Preferred location is required';
                }
                break;
            case 'partner_education':
                if (!value || value === '') {
                    error = "Partner's education preference is required";
                }
                break;
            case 'partner_occupation':
                if (!value || value === '') {
                    error = "Partner's occupation preference is required";
                }
                break;
            default:
                break;
        }
        
        setErrors(prev => ({ ...prev, [fieldName]: error }));
        return error === '';
    };

    const validateForm = () => {
        const fieldsToValidate = [
            'looking_for', 'marit', 'age', 'location', 
            'partner_education', 'partner_occupation'
        ];
        
        let isValid = true;
        const newErrors = {};
        
        fieldsToValidate.forEach(field => {
            const value = localData[field];
            let error = '';
            
            switch (field) {
                case 'looking_for':
                    if (!value || value === '') {
                        error = 'Please select what you are looking for';
                    }
                    break;
                case 'marit':
                    if (!value || value === '') {
                        error = "Partner's marital status preference is required";
                    }
                    break;
                case 'age':
                    if (!value || value === '') {
                        error = 'Preferred age gap is required';
                    }
                    break;
                case 'location':
                    if (!value || value === '') {
                        error = 'Preferred location is required';
                    }
                    break;
                case 'partner_education':
                    if (!value || value === '') {
                        error = "Partner's education preference is required";
                    }
                    break;
                case 'partner_occupation':
                    if (!value || value === '') {
                        error = "Partner's occupation preference is required";
                    }
                    break;
                default:
                    break;
            }
            
            if (error) {
                isValid = false;
                newErrors[field] = error;
            }
        });
        
        setErrors(newErrors);
        
        // Mark all fields as touched
        const allTouched = {};
        fieldsToValidate.forEach(field => {
            allTouched[field] = true;
        });
        setTouched(allTouched);
        
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const submissionData = {
                user_id: userId,
                looking_for: localData.looking_for || '',
                marit: localData.marit || '',
                age: localData.age || '',
                partner_education: localData.partner_education || '',
                partner_occupation: localData.partner_occupation || '',
                location: localData.location || ''
            };
            
            console.log('Submitting partner preferences:', submissionData);
            onSubmit(submissionData);
        } else {
            toast.error('Please fill all required fields');
        }
    };

    // Helper function to get selected option label
    const getLookingForLabel = () => {
        const selected = lookingForOptions.find(opt => opt.value === localData.looking_for);
        return selected ? selected.label : 'Not selected';
    };

    const getMaritLabel = () => {
        const selected = meritOptions.find(opt => opt.value === localData.marit);
        return selected ? selected.label : 'Not selected';
    };

    const getAgeLabel = () => {
        const selected = ageGapOptions.find(opt => opt.value === localData.age);
        return selected ? selected.label : 'Not selected';
    };

    const getLocationLabel = () => {
        const selected = locationOptions.find(opt => opt.value === localData.location);
        return selected ? selected.label : 'Not selected';
    };

    const getEducationLabel = () => {
        const selected = educationOptions.find(opt => opt.value === localData.partner_education);
        return selected ? selected.label : 'Not selected';
    };

    const getOccupationLabel = () => {
        const selected = occupationOptions.find(opt => opt.value === localData.partner_occupation);
        return selected ? selected.label : 'Not selected';
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="flex items-center space-x-2 mb-6">
                <FaHeart className="text-pink-600 text-xl" />
                <h2 className="text-2xl font-bold text-gray-800">Partner Preferences</h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Looking For */}
                <div>
                    <label className="form-label">
                        <FaHeart className="inline mr-2 text-pink-500" />
                        Looking For <span className="text-red-500">*</span>
                    </label>
                    <select
                        name="looking_for"
                        value={localData.looking_for}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.looking_for && touched.looking_for ? 'input-error' : ''}`}
                    >
                        <option value="">Select Looking For</option>
                        {lookingForOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {errors.looking_for && touched.looking_for && <p className="error-message">{errors.looking_for}</p>}
                </div>
                
                {/* Partner's Marital Status Preference */}
                <div>
                    <label className="form-label">
                        <FaStar className="inline mr-2 text-yellow-500" />
                        Partner's Marital Status <span className="text-red-500">*</span>
                    </label>
                    <select
                        name="marit"
                        value={localData.marit}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.marit && touched.marit ? 'input-error' : ''}`}
                    >
                        <option value="">Select Preferred Marital Status</option>
                        {meritOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {errors.marit && touched.marit && <p className="error-message">{errors.marit}</p>}
                </div>
                
                {/* Age Gap */}
                <div>
                    <label className="form-label">
                        <FaCalendarAlt className="inline mr-2 text-blue-500" />
                        Preferred Age Gap <span className="text-red-500">*</span>
                    </label>
                    <select
                        name="age"
                        value={localData.age}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.age && touched.age ? 'input-error' : ''}`}
                    >
                        <option value="">Select Age Gap Preference</option>
                        {ageGapOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {errors.age && touched.age && <p className="error-message">{errors.age}</p>}
                    <p className="text-xs text-gray-500 mt-1">Age difference preference</p>
                </div>
                
                {/* Location Preference */}
                <div>
                    <label className="form-label">
                        <FaMapMarkerAlt className="inline mr-2 text-green-500" />
                        Preferred Location <span className="text-red-500">*</span>
                    </label>
                    <select
                        name="location"
                        value={localData.location}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.location && touched.location ? 'input-error' : ''}`}
                    >
                        <option value="">Select Preferred Location</option>
                        {locationOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {errors.location && touched.location && <p className="error-message">{errors.location}</p>}
                    <p className="text-xs text-gray-500 mt-1">Where do you prefer your partner to be from?</p>
                </div>
                
                {/* Partner Education */}
                <div>
                    <label className="form-label">
                        <FaGraduationCap className="inline mr-2 text-purple-500" />
                        Partner's Education <span className="text-red-500">*</span>
                    </label>
                    <select
                        name="partner_education"
                        value={localData.partner_education}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.partner_education && touched.partner_education ? 'input-error' : ''}`}
                    >
                        <option value="">Select Preferred Education</option>
                        {educationOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {errors.partner_education && touched.partner_education && <p className="error-message">{errors.partner_education}</p>}
                </div>
                
                {/* Partner Occupation */}
                <div>
                    <label className="form-label">
                        <FaBriefcase className="inline mr-2 text-orange-500" />
                        Partner's Occupation <span className="text-red-500">*</span>
                    </label>
                    <select
                        name="partner_occupation"
                        value={localData.partner_occupation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.partner_occupation && touched.partner_occupation ? 'input-error' : ''}`}
                    >
                        <option value="">Select Preferred Occupation</option>
                        {occupationOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {errors.partner_occupation && touched.partner_occupation && <p className="error-message">{errors.partner_occupation}</p>}
                </div>
            </div>
            
            {/* Registration Summary */}
            <div className="mt-8 p-6 bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl border border-pink-100">
                <h3 className="font-bold text-lg text-gray-800 mb-4 flex items-center">
                    <FaHeart className="text-pink-600 mr-2" />
                    Registration Summary
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                    <div className="space-y-2">
                        <p><strong>Name:</strong> {formData.name || 'Not provided'}</p>
                        <p><strong>DOB:</strong> {formData.dob || 'Not provided'}</p>
                        <p><strong>Gender:</strong> {formData.gender || 'Not provided'}</p>
                        <p><strong>Marital Status:</strong> {formData.marital || 'Not provided'}</p>
                    </div>
                    <div className="space-y-2">
                        <p><strong>Education:</strong> {formData.education || 'Not provided'}</p>
                        <p><strong>Occupation:</strong> {formData.occupation || 'Not provided'}</p>
                        <p><strong>Amount:</strong> Rs. 4,000</p>
                    </div>
                </div>
                <div className="mt-4 pt-4 border-t border-pink-200">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <p><strong>Looking For:</strong> {getLookingForLabel()}</p>
                        <p><strong>Partner's Marital Status:</strong> {getMaritLabel()}</p>
                        <p><strong>Age Gap:</strong> {getAgeLabel()}</p>
                        <p><strong>Preferred Location:</strong> {getLocationLabel()}</p>
                        <p><strong>Partner's Education:</strong> {getEducationLabel()}</p>
                        <p><strong>Partner's Occupation:</strong> {getOccupationLabel()}</p>
                    </div>
                </div>
            </div>
            
            <div className="flex justify-between pt-4">
                <button
                    type="button"
                    onClick={onPrevious}
                    disabled={loading}
                    className="btn-secondary flex items-center space-x-2"
                >
                    <FaArrowLeft />
                    <span>Previous</span>
                </button>
                <button
                    type="submit"
                    disabled={loading}
                    className="btn-success flex items-center space-x-2"
                >
                    {loading ? (
                        <>
                            <div className="w-5 h-5 border-t-2 border-white rounded-full animate-spin"></div>
                            <span>Submitting...</span>
                        </>
                    ) : (
                        <>
                            <FaCheck />
                            <span>Complete Registration</span>
                        </>
                    )}
                </button>
            </div>
        </form>
    );
};

export default LifePartnerPreferences;